import AsyncPublishingOptionsModal from 'content-management-actions-lib/modals/AsyncPublishingOptionsModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ROW_ACTION_GROUPS } from 'content-management-actions-lib/constants/actionGroups';
import { CONTENT_ACTION_IDS } from 'content-management-actions-lib/constants/actionIds';
import { CONTENT_PLATFORM_PROPERTY_NAME, ContentObjectTypes, contentIsTranslation, getContentPropertyValue, useAuthInfoProvider } from 'content-management-data-lib';
import { ContentTypes } from 'ui-memberships-settings-lib/constants/ContentTypes';
import MoveSubcategoryModal from '../components/modals/MoveSubcategoryModal';
import { getDetailsUrl, getEditorUrl } from '../utils/urls';
import { PAGE_ACTION_IDS } from './actionIds';
import { LANDING_PAGES_ACCESS, LANDING_PAGES_MULTILANGUAGE, LANDING_PAGES_WRITE, PAGE_SUBCATEGORY_MOVE_ACCESS, SITE_PAGES_ACCESS, SITE_PAGES_MULTILANGUAGE, SITE_PAGES_WRITE, UPDATE_LANDING_PAGES_SCOPES, UPDATE_SITE_PAGES_SCOPES } from './scopes';
import { ContentPrerenderViewActionButton } from 'content-management-actions-lib/components/ContentPrerenderViewActionButton';
import { isContentObjectPersonalized } from '../utils/personalization';
import { jsx as _jsx } from "react/jsx-runtime";
export const ActionIdsWithoutSuccessBanners = [CONTENT_ACTION_IDS.EDIT, CONTENT_ACTION_IDS.VIEW, CONTENT_ACTION_IDS.CLONE];
const LANDING_PAGE_CONTENT_TYPE = 'LANDING_PAGE';
const SITE_PAGE_CONTENT_TYPE = 'SITE_PAGE';
export const ViewConfig = {
  id: CONTENT_ACTION_IDS.VIEW,
  TableRowCustomActionButton: () => {
    const {
      userInfo: {
        gates,
        user: {
          scopes
        }
      }
    } = useAuthInfoProvider();
    const contentType = window.location.href.includes('pages/landing') ? LANDING_PAGE_CONTENT_TYPE : SITE_PAGE_CONTENT_TYPE;

    // Determine the appropriate scope based on content type
    const brandingScope = contentType === LANDING_PAGE_CONTENT_TYPE ? 'landingpages-no-branding' : 'website-pages-no-branding';

    // Check if content is on free tier based on the correct scope
    const isContentOnFreeTier = !scopes.includes(brandingScope);
    return /*#__PURE__*/_jsx(ContentPrerenderViewActionButton, {
      isContentOnFreeTier: isContentOnFreeTier,
      gates: gates,
      scopes: scopes
    });
  },
  orderInTableRowActionGroup: 1
};
const EditConfig = {
  id: CONTENT_ACTION_IDS.EDIT,
  onActionButtonClick: (crmObject, extraProps) => {
    const id = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
    const editorUrl = getEditorUrl(id);
    if (extraProps && extraProps.shouldOpenInNewTab) {
      window.open(editorUrl);
    } else {
      window.location.href = getEditorUrl(id);
    }
  }
};
export const SitePageEditConfig = Object.assign({}, EditConfig, {
  displayPermissions: {
    scopes: [SITE_PAGES_ACCESS, SITE_PAGES_WRITE]
  }
});
export const LandingPageEditConfig = Object.assign({}, EditConfig, {
  displayPermissions: {
    scopes: [LANDING_PAGES_ACCESS, LANDING_PAGES_WRITE]
  }
});
export const PageRunTestConfig = {
  id: CONTENT_ACTION_IDS.RUN_A_TEST,
  displayPermissions: {
    custom: () => false
  }
};
export const AssignUsersAndTeamsConfig = {
  id: CONTENT_ACTION_IDS.ASSIGN_PERMISSIONS,
  displayPermissions: {
    custom: () => false
  }
};
export const SitePageDetailsConfig = {
  id: CONTENT_ACTION_IDS.DETAILS,
  onActionButtonClick: crmObject => {
    const id = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
    window.location.href = getDetailsUrl({
      contentObjectType: ContentObjectTypes.SITE_PAGE,
      id
    });
  },
  displayPermissions: {
    scopes: [SITE_PAGES_ACCESS]
  }
};
export const SitePagePublishingOptionsConfig = {
  id: CONTENT_ACTION_IDS.PUBLISHING_OPTIONS,
  ModalOrPanel: modalProps => /*#__PURE__*/_jsx(AsyncPublishingOptionsModal, Object.assign({}, modalProps, {
    membershipsContentType: ContentTypes.SITE_PAGE
  })),
  displayPermissions: {
    scopes: UPDATE_SITE_PAGES_SCOPES
  }
};
export const SitePageUnpublishingOptionsConfig = {
  id: CONTENT_ACTION_IDS.UNPUBLISHING_OPTIONS,
  displayPermissions: {
    scopes: UPDATE_SITE_PAGES_SCOPES
  }
};
export const SitePageDeleteConfig = {
  id: CONTENT_ACTION_IDS.DELETE,
  displayPermissions: {
    scopes: UPDATE_SITE_PAGES_SCOPES
  }
};
export const SitePageArchiveConfig = {
  id: CONTENT_ACTION_IDS.ARCHIVE,
  displayPermissions: {
    scopes: UPDATE_SITE_PAGES_SCOPES
  }
};
export const SitePageAddToLangGroupConfig = {
  id: CONTENT_ACTION_IDS.ADD_TO_LANGUAGE_GROUP,
  displayPermissions: {
    scopes: [...UPDATE_SITE_PAGES_SCOPES, SITE_PAGES_MULTILANGUAGE]
  }
};
export const SitePageRemoveFromLangGroupConfig = {
  id: CONTENT_ACTION_IDS.REMOVE_FROM_LANGUAGE_GROUP,
  displayPermissions: {
    scopes: [...UPDATE_SITE_PAGES_SCOPES, SITE_PAGES_MULTILANGUAGE]
  }
};
export const LandingPageDetailsConfig = {
  id: CONTENT_ACTION_IDS.DETAILS,
  onActionButtonClick: crmObject => {
    const id = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
    window.location.href = getDetailsUrl({
      contentObjectType: ContentObjectTypes.LANDING_PAGE,
      id
    });
  },
  displayPermissions: {
    scopes: [LANDING_PAGES_ACCESS]
  }
};
export const LandingPagePublishingOptionsConfig = {
  id: CONTENT_ACTION_IDS.PUBLISHING_OPTIONS,
  ModalOrPanel: modalProps => /*#__PURE__*/_jsx(AsyncPublishingOptionsModal, Object.assign({}, modalProps, {
    membershipsContentType: ContentTypes.LANDING_PAGE
  })),
  displayPermissions: {
    scopes: UPDATE_LANDING_PAGES_SCOPES
  }
};
export const LandingPageUnpublishingOptionsConfig = {
  id: CONTENT_ACTION_IDS.UNPUBLISHING_OPTIONS,
  displayPermissions: {
    scopes: UPDATE_LANDING_PAGES_SCOPES
  }
};
export const LandingPageDeleteConfig = {
  id: CONTENT_ACTION_IDS.DELETE,
  displayPermissions: {
    scopes: UPDATE_LANDING_PAGES_SCOPES
  },
  enablePermissions: {
    custom: ({
      crmObjects,
      isBulkAction
    }) => {
      if (isBulkAction) {
        return !crmObjects.some(isContentObjectPersonalized);
      }
      return true;
    },
    skipDefaultValidationCallback: false
  },
  DisabledTooltipContent: ({
    crmObjects
  }) => {
    if (crmObjects.some(isContentObjectPersonalized)) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-lib.personalization.noBulkDelete"
      });
    }
  }
};
export const LandingPageArchiveConfig = {
  id: CONTENT_ACTION_IDS.ARCHIVE,
  displayPermissions: {
    scopes: UPDATE_LANDING_PAGES_SCOPES
  }
};
export const LandingPageAddToLangGroupConfig = {
  id: CONTENT_ACTION_IDS.ADD_TO_LANGUAGE_GROUP,
  displayPermissions: {
    scopes: [...UPDATE_LANDING_PAGES_SCOPES, LANDING_PAGES_MULTILANGUAGE]
  },
  enablePermissions: {
    // Users should not be able to add personalized pages to multilang groups
    custom: ({
      crmObjects
    }) => !crmObjects.some(isContentObjectPersonalized)
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "page-lib.personalization.multiLangDisabledTooltip"
  })
};
export const LandingPageRemoveFromLangGroupConfig = {
  id: CONTENT_ACTION_IDS.REMOVE_FROM_LANGUAGE_GROUP,
  displayPermissions: {
    scopes: [...UPDATE_LANDING_PAGES_SCOPES, LANDING_PAGES_MULTILANGUAGE]
  }
};
export const MoveToSitePagesConfig = {
  id: PAGE_ACTION_IDS.MOVE_SUBCATEGORY,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "page-lib.actions.moveToSitePages"
  }),
  displayPermissions: {
    scopes: [LANDING_PAGES_ACCESS, LANDING_PAGES_WRITE, PAGE_SUBCATEGORY_MOVE_ACCESS, SITE_PAGES_ACCESS],
    custom: ({
      crmObjects
    }) => crmObjects.length > 0 && !contentIsTranslation(crmObjects[0])
  },
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  orderInTableRowActionGroup: 4,
  ModalOrPanel: MoveSubcategoryModal
};
export const MoveToLandingPagesConfig = {
  id: PAGE_ACTION_IDS.MOVE_SUBCATEGORY,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "page-lib.actions.moveToLandingPages"
  }),
  displayPermissions: {
    scopes: [SITE_PAGES_ACCESS, SITE_PAGES_WRITE, PAGE_SUBCATEGORY_MOVE_ACCESS, LANDING_PAGES_ACCESS],
    custom: ({
      crmObjects
    }) => crmObjects.length > 0 && !contentIsTranslation(crmObjects[0])
  },
  tableRowActionGroup: ROW_ACTION_GROUPS.ADVANCED,
  orderInTableRowActionGroup: 4,
  ModalOrPanel: MoveSubcategoryModal
};